// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import {img_url} from '../ui/img_url';
import cn from 'classnames';
import {mobile_links} from '../ui/use_install_info';
import {guess_os_and_version} from '../client_hints_global';
import {guess_browser} from 'zuser_agent';
import {Button} from '../../../shared/button';
import styles from './feature_cards.module.less';

const get_link_by_os_and_device = (os: string, device: string)=>{
    if (mobile_links[os])
        return mobile_links[os];
    if (mobile_links[device])
        return mobile_links[device];
    if (os==='macos')
      return mobile_links['ios'];
    return mobile_links.all;
};

interface i_card_data {
    title: string;
    subtitle: string;
    img: string;
}

const cards_data: i_card_data[] = [
    {
        title: 'Browser Extensions',
        subtitle: 'For Chrome, Opera and Microsoft Edge',
        img: 'hola2023/products_discover_ext.svg',
    },
    {
        title: 'Phone Apps',
        // XXX dmitriikup: URG request from noav to remove all Samsung
        // mentions from www
        // subtitle: 'For iOS, Samsung and Huawei',
        subtitle: 'For iOS, Huawei and Android',
        img: 'hola2023/products_discover_mobile.svg',
    },
    {
        title: 'Desktop Apps',
        subtitle: 'For Windows and MacOS',
        img: 'hola2023/products_discover_desktop.svg',
    },
    {
        title: 'TV Apps',
        subtitle: 'For Fire TV, LG TV, Apple TV and Smart TV',
        img: 'hola2023/products_discover_tv.svg',
    },
    {
        title: 'More Products',
        subtitle: 'Gaming apps, routers and smart DNS',
        img: 'hola2023/products_discover_others.svg',
    }
];

const Card = (props: i_card_data)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.card}>
      <img src={img_url(props.img)} alt={props.title} className="lazyload"/>
      <p className={cn([theme.mono16, theme.med, styles.title,
        theme.color_n700])}>{props.title}</p>
      <p className={cn([theme.p3, styles.subtitle])}>{props.subtitle}</p>
    </div>;
};

export const Feature_cards = ()=>{
    const {theme} = useContext(Settings_context);
    const sys = guess_os_and_version();
    const b = guess_browser();
    // XXX dmitriikup: URG request from noav to remove all Samsung
    // mentions from www
    // const link = get_link_by_os_and_device(sys.os, b.huawei ? 'huawei' :
    //     b.samsung ? 'samsung': 'all');
    const link = get_link_by_os_and_device(sys.os, b.huawei ?
        'huawei' :'android');
    return <div className={theme.container}>
      <div className={styles.feature_cards_container}>
        <div className={styles.cards}>
          {cards_data.map((card, idx)=>
            <Card key={idx} title={card.title} subtitle={card.subtitle}
              img={card.img}/>)}
        </div>
        <Button caption="Get Hola free VPN" color="black2023" size="lg"
          to={link} arrow/>
      </div>
    </div>;
};

interface i_feature_cards_editor_props {
    value: unknown;
    on_change: (value: unknown)=>void;
}

export const Feature_cards_editor = (props: i_feature_cards_editor_props)=>{
    return <Editor editors={[]}
      value={props.value} on_change={props.on_change} />;
};
